import { editablePageGroups } from '../../update-page-groups'
import type { Contract, PageGroupType, STDocument } from '@st/sdk'
import { createElement } from 'react'
import { match } from '@st/pattern'
import { TaxReturnDeliveryTopBar } from './top-bar'
import type { DocumentView } from '../types'
import { taxReturnDeliveryDocumentState } from './state'
import { DeliveryPageGroups } from './page-groups-sidebar'
import { TaxReturnDeliverySidebar } from './sidebar'

export function taxReturnDeliveryDocumentView({
  groupTypes,
  document,
  publishedContract,
  drafts,
  canEdit,
  canEditFields,
  baseView
}: {
  groupTypes: PageGroupType[]
  document: STDocument
  publishedContract: Contract | undefined
  drafts: Contract[]
  canEdit: boolean
  canEditFields: boolean
  baseView: DocumentView
}): DocumentView | undefined {
  const state = taxReturnDeliveryDocumentState(publishedContract, drafts, document.id)
  const groupView = {
    ...baseView,
    pageGroups: () => editablePageGroups(document),
    renderSidebar: () => null,
    renderTopBar: () => createElement(TaxReturnDeliveryTopBar, { state })
  }
  if (!state) {
    if (document.documentTypeId !== 'tax_return_packet') return undefined
    return {
      ...groupView,
      viewerOptions: () => ({ ...baseView.viewerOptions(), pageGroupMode: 'enabled' })
    }
  }

  const contract = state.contract

  return {
    ...groupView,
    renderSidebar: ({ sendViewerMessage }) =>
      match(contract.status)
        .with('draft', () => ({
          title: 'Tax return delivery',
          widthClassName: 'w-80',
          className: 'bg-gray-100',
          content: createElement(TaxReturnDeliverySidebar, {
            pageGroupEditor: createElement(DeliveryPageGroups, {
              groups: groupView.pageGroups(),
              groupTypes,
              sendViewerMessage
            })
          })
        }))
        .otherwise(() => null),
    viewerOptions: () => ({
      readOnly: true,
      annotationToolsEnabled: canEditFields,
      pageGroupMode: match({ status: contract.status, canEdit })
        .with({ status: 'draft', canEdit: true }, () => 'enabled' as const)
        .otherwise(() => 'hidden' as const)
    })
  }
}
